// P13 — Disclaimer G5: modal que aparece no PRIMEIRO acesso a /agentes.
//
// Versionado em localStorage (`agents_terms_accepted_v1`) — pra forçar re-aceite
// se o termo mudar (v2, v3...). Não-dismissable (precisa clicar "Entendi").

import { FC, useEffect, useState } from 'react';

const STORAGE_KEY = 'agents_terms_accepted_v1';

const TermsModal: FC = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        setOpen(true);
      }
    } catch {
      // localStorage indisponível (modo anônimo, etc) — não abre o modal,
      // dá pra usar agentes mesmo sem registrar aceite.
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    } catch {
      // noop
    }
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4"
      data-testid="terms-modal"
    >
      <div className="bg-surface-primary border border-surface-border rounded-xl max-w-md w-full p-6 space-y-4">
        <h2 className="text-xl font-bold text-content-primary">
          Como usamos seus dados nos agentes
        </h2>
        <ul className="space-y-3 text-sm text-content-primary">
          <li className="flex gap-2">
            <span aria-hidden>🔒</span>
            <span>
              <strong>Agente Pessoal:</strong> apenas você acessa o conteúdo das suas conversas.
            </span>
          </li>
          <li className="flex gap-2">
            <span aria-hidden>🔓</span>
            <span>
              <strong>Agente de Setor ou Global:</strong> administradores podem revisar conversas
              para fins de qualidade e auditoria.
            </span>
          </li>
          <li className="flex gap-2">
            <span aria-hidden>📊</span>
            <span>
              Metadados de uso (tokens, custo, modelo) são sempre registrados para controle de
              cotas.
            </span>
          </li>
          <li className="flex gap-2">
            <span aria-hidden>🗑️</span>
            <span>Você pode arquivar conversas a qualquer momento na tela do chat.</span>
          </li>
        </ul>
        <button
          type="button"
          onClick={accept}
          data-testid="terms-accept"
          className="w-full bg-accent hover:bg-accent-hover text-accent-contrast font-semibold py-2.5 rounded-lg transition-colors"
        >
          Entendi
        </button>
      </div>
    </div>
  );
};

export default TermsModal;
